module.exports = __webpack_public_path__ + "static/media/avaliacao-de-imoveis-online.2f731fad.jpg";